<template>
  <div id="features">
    <h2 class="capitalize">{{ $t('features') }}</h2>
    <div>
      <textarea class="notes" v-model="sheet.input.features" rows="10"></textarea>
    </div>
  </div>
</template>

<script>
export default {
  props: [ 'sheet' ]
}
</script>
